export var erpApi="https://api.rainben.cn/erp"
export var adminApi="https://api.rainben.cn/admin"
export var domainApi="https://api.rainben.cn"

